module.exports = __webpack_public_path__ + "static/media/iconCanvas11.68b03b8c.svg";